<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/build' }">党建专栏</el-breadcrumb-item>
        <el-breadcrumb-item>党建详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>总书记在三中全会上的重要讲话发表，一起学习领悟！</h2>
        <p style="text-align: right"><span style="margin-right: 60px">2024-10-09</span></p>
        <p>《求是》杂志16日发表习近平总书记的重要文章《在党的二十届三中全会第二次全体会议上的讲话》。</p>
        <p>习近平总书记在这次重要讲话中，对如何贯彻落实三中全会精神提出“要深入学习领会全会精神”“要切实抓好《决定》部署的贯彻落实”“要扎实做好下半年工作”等明确要求。我们以摘要的形式，梳理其中要点，和大家一起学习领悟。</p>
        <p class="blue01">【要深入学习领会全会精神】</p>
        <p class="blue01">第一，深刻领会和把握进一步全面深化改革的主题。</p>
        <p>新征程上，我们靠什么来进一步凝心聚力？就是要靠中国式现代化。进一步全面深化改革，必须紧紧围绕推进中国式现代化这个主题来展开。</p>
        <p class="blue01">第二，深刻领会和把握进一步全面深化改革的重大原则。</p>
        <p>“六个坚持”原则，对于增强进一步全面深化改革的科学性、预见性、主动性、创造性，推动改革行稳致远，具有重大指导意义。这些原则，必须在改革实践中毫不动摇坚持并不断丰富和发展。</p>
        <p class="blue01">第三，深刻领会和把握进一步全面深化改革的重大举措。</p>
        <p>
          《决定》提出一系列重大改革举措，覆盖推进中国式现代化方方面面；奔着问题去，着力健全制度、破除体制机制障碍，既立足当下又着眼长远。全党同志要站在战略和全局的高度来认识和把握这些重大改革举措，领会好改革意图，把握准改革指向，坚定不移予以推进。
        </p>
        <p class="blue01">第四，深刻领会和把握进一步全面深化改革的根本保证。</p>
        <p>进一步全面深化改革，必须在党中央集中统一领导下进行，保证改革始终沿着正确政治方向前进。</p>
        <p class="blue01">【要切实抓好《决定》部署的贯彻落实】</p>
        <p class="blue01">第一，加强组织领导。</p>
        <p>要精心组织、统筹协调，科学制定改革任务书、时间表、优先序，明确各项改革实施主体和责任。</p>
        <p class="blue01">第二，坚持整体推进。</p>
        <p>贯彻落实中既不能单打独斗、单兵突进，又不能打乱仗、眉毛胡子一把抓。</p>
        <p>●要坚持先立后破、不立不破，准确把握改革的战略重点，合理安排改革举措的先后顺序、节奏时机，根据轻重缓急循序渐进、稳扎稳打，不超前、不滞后。</p>
        <p>●当前反映最为集中、最为迫切、需要打攻坚战的，就抓紧改；需要久久为功、打持久战的，就徐图之。</p>
        <p>●要加强各项改革举措协调配合，增强改革取向的一致性，坚决防止和克服本位主义，不能因部门利益、地方利益影响改革大局。</p>
        <p>●要保持工作连续性，过去已经定下来的改革，要继续抓好落实，新部署的改革要抓紧研究方案、扎实推进。</p>
        <p class="blue01">第三，鼓励探索创新。</p>
        <p>各地区各部门要树立全国一盘棋思想，自觉在大局下行动；同时，找准自身面临的主要矛盾和矛盾的主要方面，制定切合实际的具体改革举措，防止照抄照搬、上下一般粗。</p>
        <p>●对已经确定必须取得突破但一时还没有实践经验的改革，要采取试点先行探索的办法，取得经验、看准了再推开。</p>
        <p>●对新领域新实践遇到的新问题，要充分尊重基层和群众首创精神，鼓励开拓创新，不断创造和积累可复制、可推广的新鲜经验。</p>
        <p class="blue01">第四，务求取得实效。</p>
        <p>要建立健全责任明晰、链条完整、环环相扣的改革推进机制，从改革方案设计到改革组织实施都要有利于抓落实、有利于解决问题，防止重文件制定轻文件落实等不良倾向。</p>
        <p>牢固树立改革没有局外人旁观者的观念，推动广大党员、干部紧密结合工作职责，把改革任务落细落小落实。</p>
        <p class="blue01">【要扎实做好下半年工作】</p>
        <p class="blue01">第一，坚定不移实现全年经济社会发展目标。</p>
        <p>要落实好宏观政策，积极扩大国内需求，因地制宜发展新质生产力，加快培育外贸新动能，扎实推进绿色低碳发展，切实保障和改善民生，巩固拓展脱贫攻坚成果。</p>
        <p class="blue01">第二，统筹好发展和安全。</p>
        <p>要落实好防范化解重点领域风险的各项举措，严格落实安全生产责任，完善自然灾害特别是洪涝灾害监测、防控措施，织密社会安全风险防控网，切实维护社会稳定。</p>
        <p>要有效应对外部风险挑战，主动塑造有利外部环境。</p>
        <p class="blue01">第三，搞好“五年规划”总结评估和谋划工作。</p>
        <p>要提前研究，总结评估“十四五”规划落实情况，切实搞好“十五五”规划前期谋划工作。</p>
        <p class="blue01">第四，纵深推进全面从严治党。</p>
        <p>抓好党的创新理论武装；健全全面从严治党体系；切实改进作风，克服形式主义、官僚主义顽疾，持续为基层减负；巩固拓展主题教育成果。</p>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px">
            &nbsp;&nbsp;&nbsp;&nbsp;
            <!-- &lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;又踏层峰辟新天——《中共中央关于进一步全面深化改革、推进中国式现代化的决定》... -->
          </span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build8' })">又踏层峰辟新天——《中共中央关于...&nbsp;&nbsp;&nbsp;&nbsp;下一条
            &gt;</span>
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.kongxi {
  height: 10px;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }

  .blue01 {
    font-weight: bold;
    color: #000080;
  }
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}
</style>